import {Color} from "../constants/consts-types"

export const colorInverter = colors => {
  return {
    backgroundColor: colors.foreground ? colors.foreground : Color.BLACK,
    color: colors.background ? colors.background : Color.GREY_LIGHT
  }
}

export const colorsDefault = {
  foreground: Color.BLACK,
  background: Color.GREY_LIGHT
}
export const colorsDefaultInverted = {
  background: Color.BLACK,
  foreground: Color.GREY_LIGHT
}


// WEBPACK FOOTER //
// ./src/services/service-color-inverter.js